import { checkEnrichedName } from "bto-models/utils/string";
/**
 * Model for Match Odds for Match Details
 */
export default class MatchDetailsOddModel {
  /**
   * class constructor method
   * @param data
   */
  constructor(data, homeTeam = '', guestTeam = '', tabId = 0) {
    /**
     * Odds ID
     * @type {number}
     */
    this.marketId = data.id;
    /**
     * Odds Name (Market Name?)
     * @type {string}
     */
    this.marketName = data.n;
    /**
     * Description of the market
     * @type {string}
     */
    this.marketDescription = data.dm;
    /**
    /* Extra id, we create this id because we have cases where we have multiple markets with same id,
    /* so this is a way do make distinction between them
    /* @type {string}
     */
    this.extraId = data.n ? `${data.n.replaceAll(" ", "")}_${data.id}` : null;
    /**
     * If this odd is combination with other odds
     * Single = 1, can be played only single
     * Unique = 2, can be played as a single at least
     * Trebles = 3, can be played in a combination with at least three other
     * Quadruple = 4, can be played in a combination with at least four other
     * Quintuple = 5 can be played in a combination with at least five
     * @type {number}
     */
    this.isCombo = data.c;
    /**
     * Outcomes array
     * @type {array}
     */
    this.outcomes = [];
    /**
     * Odd type identifier
     * @type {string}
     */
    this.otIdentifier = data.oti;
    /**
     * Special bet value
     * @type {null}
     */
    this.specialBetValue = typeof data.sbv !== "undefined" ? data.sbv : null;
    /**
     * Enriched Market Names
     * @type {string}
     */
    this.enrichedMarketName = checkEnrichedName(data.emn, homeTeam, guestTeam, data.sbv);
    /**
     * Cashout
     * @type {boolean}
     */
    this.cashout = data.ca || false;
    /**
     * Id of the tab were the marked is sorted
     * @type {number}
     */
    this.tabId = tabId;
  }
}
